<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title d-flex align-items-center flex-wrap">
                Solicitação de Reembolso #{{ reimbursement_solicitation.id }}
                <span :class="['badge', statusBadge.badge, 'ml-1']" style="font-size: 14px">
                  {{ statusBadge.text }}
                </span>
                <span v-if="reimbursement_solicitation.is_contested" class="badge badge-warning ml-50" style="font-size: 14px">
                  CONTESTADO
                </span>
              </div>

              <div class="row">
                <a
                  v-if="
                    $store.state.user.perfil_id == 7 ||
                    $store.state.user.perfil_id == 8
                  "
                  class="btn btn-back mr-2"
                  :href="reimbursement_solicitation.url"
                  target="_blank"
                >
                  <i class="fas fa-file-pdf"></i> Exportar PDF
                </a>
              </div>
            </div>

            <hr style="margin-top: -4px" />

            <div class="col-12 mt-2" v-if="reimbursement_solicitation.is_contested">
              <contest-banner :items="reimbursements" :reviewing="isReviewing" />
            </div>

            <div class="col-12 mt-4 mb-2">
              <div
                :class="[
                  'reimbursement-card',
                  $store.state.appConfig.layout.skin === 'dark'
                    ? 'reimbursement-card-dark'
                    : 'reimbursement-card-light',
                ]"
              >
                <div class="reimbursement-card-header">
                  <i
                    class="fas fa-user-circle text-primary"
                    style="font-size: 22px"
                  ></i>
                  <h3 class="mb-0 text-primary reimbursement-card-title">
                    Dados da Solicitação
                  </h3>
                  <div
                    class="reimbursement-card-line reimbursement-card-line-primary"
                  ></div>
                </div>

                <div class="row">
                  <div class="col-md-5">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                      ><span class="required">*</span> Nome do
                      Colaborador</label
                    >
                    <input
                      :value="
                        reimbursement_solicitation.user
                          ? reimbursement_solicitation.user.name
                          : ''
                      "
                      type="text"
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      disabled
                    />
                  </div>

                  <div class="col-md-5">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                      >Valor do Adiantamento</label
                    >
                    <input
                      :value="formattedAdvanceAmount"
                      type="text"
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      disabled
                    />
                  </div>

                  <div class="col-md-2">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                      >Data da solicitação</label
                    >
                    <input
                      autocomplete="new-password"
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      id="date"
                      placeholder=""
                      type="date"
                      v-model="reimbursement_solicitation.date"
                      disabled
                    />
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-md-4">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                      ><span class="required">*</span> Banco</label
                    >
                    <input
                      v-model="reimbursement_solicitation.deposit_bank"
                      type="text"
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      disabled
                    />
                  </div>

                  <div class="col-md-4">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                      ><span class="required">*</span> Agência</label
                    >
                    <input
                      v-model="reimbursement_solicitation.branch"
                      type="text"
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      disabled
                    />
                  </div>

                  <div class="col-md-4">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                      >Conta Corrente</label
                    >
                    <input
                      v-model="reimbursement_solicitation.checking_account"
                      type="text"
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 mt-4 mb-2" v-if="reimbursements.length > 0">
              <expense-review-table
                title="Itens de Reembolso"
                :items="reimbursements"
                :reviewing="isReviewing"
                :can-contest="can.contest"
                show-bill-center
                @decide="decide"
                @save-amount="saveAmount"
                @contest="contest"
              />
            </div>

            <div class="col-12 mt-4 mb-2" v-else>
              <div
                :class="[
                  'reimbursement-card',
                  $store.state.appConfig.layout.skin === 'dark'
                    ? 'reimbursement-card-dark'
                    : 'reimbursement-card-light',
                ]"
              >
                <div class="text-center text-muted py-4">
                  <i
                    class="fas fa-inbox"
                    style="font-size: 48px; opacity: 0.3"
                  ></i>
                  <p class="mt-2">Nenhuma despesa informada</p>
                </div>
              </div>
            </div>

            <div class="col-12 mt-4 mb-2" v-if="reimbursements.length > 0">
              <financial-summary
                mode="reimbursement"
                :totals="totals"
                :reviewing="isReviewing"
                :in-review="isInReview"
                @conclude="conclude"
              />
            </div>

            <!-- Comprovante de pagamento -->
            <div
              class="col-12 mt-4 mb-2"
              v-if="Number(reimbursement_solicitation.approve) === 3 || reimbursement_solicitation.receipt"
            >
              <div
                :class="[
                  'reimbursement-card',
                  $store.state.appConfig.layout.skin === 'dark'
                    ? 'reimbursement-card-dark'
                    : 'reimbursement-card-light',
                ]"
              >
                <div class="reimbursement-card-header">
                  <i class="fas fa-file-invoice-dollar text-warning" style="font-size: 22px"></i>
                  <h3 class="mb-0 text-warning reimbursement-card-title">Comprovante</h3>
                  <div class="reimbursement-card-line" style="border-color: #ff9f43"></div>
                </div>

                <template v-if="Number(reimbursement_solicitation.approve) === 3">
                  <p class="mb-1" v-if="totals.balance_to_receive > 0">
                    O colaborador deve devolver {{ formatCurrency(totals.balance_to_receive) }} à IT4D
                    e anexar o comprovante de devolução.
                  </p>
                  <p class="mb-1" v-else>
                    A IT4D deve reembolsar {{ formatCurrency(Math.abs(totals.balance_to_receive)) }} ao colaborador.
                    O Administrador RH ou Geral deve anexar o comprovante de pagamento.
                  </p>
                  <div class="d-flex align-items-center flex-wrap" v-if="canAttachReceipt">
                    <input
                      ref="receiptFile"
                      type="file"
                      accept=".jpg,.jpeg,.png,.pdf"
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      style="max-width: 420px"
                    />
                    <button class="btn btn-success ml-1" @click="saveReceipt">
                      <i class="fas fa-upload"></i> Anexar comprovante
                    </button>
                  </div>
                </template>

                <div v-else>
                  <a :href="reimbursement_solicitation.receipt_url" target="_blank">
                    <i class="fas fa-download"></i> {{ reimbursement_solicitation.receipt }}
                  </a>
                  <div
                    v-if="reimbursement_solicitation.receipt_uploaded_by"
                    class="text-muted"
                    style="font-size: 12px"
                  >
                    Anexado por {{ reimbursement_solicitation.receipt_uploaded_by }} em
                    {{ reimbursement_solicitation.receipt_uploaded_date_f }} às
                    {{ reimbursement_solicitation.receipt_uploaded_time_f }}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="block text-right mt-2 mb-1">
                <a class="btn btn-back" @click="$router.back()">
                  <i class="fa fa-arrow-left"></i> Voltar
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Money from "v-money";
import { reimbursementStatusBadge } from "../../utils/expenseStatus";
import ExpenseReviewTable from "../../components/Expenses/ExpenseReviewTable.vue";
import FinancialSummary from "../../components/Expenses/FinancialSummary.vue";
import ContestBanner from "../../components/Expenses/ContestBanner.vue";

export default {
  name: "imageUpload",
  data() {
    return {
      moneyConfig: {
        prefix: "R$ ",
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false,
      },
      totals: { advance_amount: 0, total_requested: 0, total_expenses: 0, total_approved: 0, balance_to_receive: 0, pending_items: 0 },
      can: { manage: false, contest: false },

      reimbursement_solicitation: {
        collaborator_name: "",
        date: "",
        checking_account: "",
        balance_to_receive: 0,
        branch: "",
        deposit_bank: "",
        country: "",
        status: "",
        bill_center_id: "",
        total_expenses: 0,
        attachments: [],
        observation: "",
        is_dinner_advance: false,
      },
      reimbursements: [],
      reimbursement_types: [],
      expense_description: "",
      reimbursement_solicitation_id: "",
      reimbursement_type_id: "",
      amount: "",
      advance_amount: "",
      bill_centers: [],
      users: [],
    };
  },
  computed: {
    isAccessNivel() {
      return (
        this.$store.state.user.perfil_id === 8 ||
        this.$store.state.user.perfil_id === 7
      );
    },

    statusBadge() {
      return reimbursementStatusBadge(
        this.reimbursement_solicitation.approve,
        this.reimbursement_solicitation.accountability_result
      );
    },

    // Em análise: aguardando aprovação (0) ou parcial do fluxo antigo (5)
    isInReview() {
      return [0, 5].includes(Number(this.reimbursement_solicitation.approve));
    },

    canAttachReceipt() {
      if (Number(this.totals.balance_to_receive) > 0) {
        return Number(this.reimbursement_solicitation.user_id) === Number(this.$store.state.user.id);
      }
      return this.isAccessNivel;
    },

    isReviewing() {
      return this.isInReview && this.can.manage;
    },

    formattedAdvanceAmount() {
      const v = parseFloat(this.reimbursement_solicitation.advance_amount);
      if (isNaN(v) || v <= 0) return "";
      return `R$ ${v.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    },

  },

  methods: {
    reviewUrl(path = "") {
      return (
        this.$store.state.api +
        "reimbursement_solicitations/" +
        this.$route.params.id +
        "/" +
        (path || "review")
      );
    },

    applyReview(response) {
      this.reimbursements = response.data.data.reimbursements || [];
      this.totals = response.data.totals;
      if (response.data.can) {
        this.can = response.data.can;
      }
      // Status/resultado mudam ao concluir a análise
      this.reimbursement_solicitation = {
        ...this.reimbursement_solicitation,
        approve: response.data.data.approve,
        accountability_result: response.data.data.accountability_result,
        is_contested: response.data.data.is_contested,
        total_expenses: response.data.data.total_expenses,
        balance_to_receive: response.data.data.balance_to_receive,
      };
    },

    reviewError(error, fallback) {
      const data = error.response && error.response.data;
      if (data && data.errors) {
        return Object.values(data.errors)[0][0];
      }
      return (data && data.message) || fallback;
    },

    // Decisão e edição de valor vêm do componente de despesas; o backend recalcula e devolve os totais
    async decide({ item, approve, observation, done }) {
      try {
        this.$loading(true);
        this.applyReview(await axios.post(this.reviewUrl(`items/${item.id}/decision`), { approve, observation }));
        done();
      } catch (error) {
        this.$message(null, this.reviewError(error, "Erro ao registrar a decisão"), "error");
      } finally {
        this.$loading(false);
      }
    },

    async saveAmount({ item, amount, done }) {
      try {
        this.$loading(true);
        this.applyReview(await axios.put(this.reviewUrl(`items/${item.id}/amount`), { amount }));
        done();
      } catch (error) {
        this.$message(null, this.reviewError(error, "Erro ao alterar o valor"), "error");
      } finally {
        this.$loading(false);
      }
    },

    async contest({ item, justification, done }) {
      try {
        this.$loading(true);
        const response = await axios.post(this.reviewUrl(`items/${item.id}/contest`), { justification });
        this.$message("Sucesso", response.data.message, "success");
        done();
        // Recarrega para atualizar status e permissões
        this.getReimbursements();
      } catch (error) {
        this.$message(null, this.reviewError(error, "Erro ao enviar a contestação"), "error");
      } finally {
        this.$loading(false);
      }
    },

    conclude() {
      const self = this;
      swal({
        title: "Concluir análise?",
        text: "Após concluir, as decisões e valores das despesas não poderão mais ser alterados.",
        icon: "warning",
        buttons: {
          cancel: { text: "Cancelar", value: false, visible: true, className: "btn-secondary" },
          confirm: { text: "Concluir", value: true, className: "btn-primary" },
        },
      }).then(async (confirmed) => {
        if (!confirmed) return;
        try {
          self.$loading(true);
          const response = await axios.post(self.reviewUrl("conclude"));
          self.applyReview(response);
          self.$message("Sucesso", response.data.message, "success");
          self.getReimbursementSolicitations(self.reimbursement_solicitation.id);
        } catch (error) {
          self.$message(null, self.reviewError(error, "Erro ao concluir a análise"), "error");
        } finally {
          self.$loading(false);
        }
      });
    },

    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },

    mFDReceipt: function () {
      const self = this;
      let fd = new FormData();
      const input = self.$refs.receiptFile;
      fd.append("id", self.reimbursement_solicitation.id);
      fd.append("receipt", input && input.files[0] ? input.files[0] : "");
      fd.append("approve", self.reimbursement_solicitation.approve);
      return fd;
    },

    saveReceipt: function () {
      const self = this;
      let api =
        self.$store.state.api + "reimbursement_solicitations/save_receipt";
      const input = self.$refs.receiptFile;
      if (!input || !input.files[0]) {
        self.$message(null, "Selecione o comprovante", "error");
        return;
      }
      let fd = self.mFDReceipt();

      self.$loading(true);
      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.getReimbursementSolicitations(
            self.reimbursement_solicitation.id
          );
          self.getReimbursements();
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },

    convertCurrencyToNumber(currencyString) {
      const numericString = currencyString.replace(/[^\d.,]/g, "");
      const numberWithDot = numericString.replace(",", ".");
      const numberValue = parseFloat(numberWithDot);
      return isNaN(numberValue) ? 0 : numberValue;
    },

    save: function () {
      const self = this;
      let api = self.$store.state.api + "reimbursement_solicitations";

      if (self.reimbursement_solicitation.id) {
        api += "/" + self.reimbursement_solicitation.id;
        self.reimbursement_solicitation._method = "PUT";
      }

      const payload = {
        reimbursement_solicitation: self.reimbursement_solicitation,
        reimbursements: self.reimbursements,
      };

      axios
        .post(api, payload)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/reimbursement_solicitations");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getReimbursementSolicitations: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "reimbursement_solicitations/" +
        id +
        "?with[]=attachments&with[]=reimbursements&with[]=user&with[]=approval_history.user_receipt";

      axios
        .get(api)
        .then((response) => {
          self.reimbursement_solicitation = response.data.data[0];

          // Adiantamentos têm tela e fluxo próprios
          if (
            self.reimbursement_solicitation &&
            Number(self.reimbursement_solicitation.is_advance) === 1
          ) {
            self.$router.replace(`/advances/view/${self.reimbursement_solicitation.id}`);
            return;
          }

          // O backend só devolve solicitações de outros usuários para RH/Geral
          if (!self.reimbursement_solicitation) {
            swal(
              "Acesso Negado",
              "Você não tem permissão para visualizar esta solicitação.",
              "error"
            );
            self.$router.push("/reimbursement_solicitations");
            return;
          }

        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    // Itens, totais e permissões vêm da API de análise (o backend calcula o saldo)
    getReimbursements: function () {
      const self = this;

      axios
        .get(self.reviewUrl())
        .then((response) => {
          self.applyReview(response);
        })
        .catch((error) => {
          self.$message(null, self.reviewError(error, "Erro ao carregar as despesas"), "error");
        });
    },
    getUsers: function () {
      const self = this;
      const api = self.$store.state.api + "users/";

      axios
        .get(api)
        .then((response) => {
          self.users = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },

  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.getUsers();

    if (id) {
      self.getReimbursementSolicitations(id);
      self.getReimbursements(id);
    }
  },

  components: {
    BaseCrud,
    vSelect,
    Money,
    ExpenseReviewTable,
    FinancialSummary,
    ContestBanner,
  },
};
</script>

<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

tr.row-rejected > td {
  color: #dc3545 !important;
}

/* ===== ESTILIZAÇÃO MODERNA - IGUAL DASP ===== */

/* Cards - Classes separadas para dark e light */
.reimbursement-card {
  border-radius: 12px;
  padding: 24px 18px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.reimbursement-card-dark {
  background: #191e2e;
  border: 1px solid #4a5568;
}

.reimbursement-card-light {
  background: #f8f8fa;
  border: 1px solid #e2e6ea;
}

.reimbursement-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}

.reimbursement-card-title {
  font-weight: 700;
}

.reimbursement-card-line {
  flex: 1;
  border-bottom: 4px solid;
  margin-left: 16px;
  opacity: 0.6;
}

.reimbursement-card-line-primary {
  border-color: #007bff;
}

/* Labels */
.reimbursement-label-dark {
  color: #e2e8f0;
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}

.reimbursement-label-light {
  color: #2d3748;
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}

/* Inputs */
.reimbursement-input-dark {
  background: #2d3748;
  border: 1px solid #4a5568;
  color: #e2e8f0;
}

.reimbursement-input-light {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #2d3748;
}

/* Cards internos */
.reimbursement-inner-card-dark {
  background: #232b3e;
  border: 1px solid #4a5568;
  border-radius: 12px;
}

.reimbursement-inner-card-light {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 12px;
}

/* ===== RESPONSIVIDADE MOBILE ===== */
@media (max-width: 768px) {
  .reimbursement-card {
    padding: 1rem 0.75rem !important;
    margin-bottom: 1rem;
  }

  .reimbursement-card-header {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }

  .reimbursement-card-header i {
    font-size: 18px !important;
  }

  .reimbursement-card-title {
    font-size: 1.1rem !important;
    margin: 0 !important;
  }

  .reimbursement-card-line {
    width: 100%;
    margin-left: 0 !important;
    margin-top: 0.5rem;
  }

  .reimbursement-label-dark,
  .reimbursement-label-light {
    font-size: 0.9rem;
    margin-bottom: 0.25rem;
  }
}

/* ===== RESPONSIVIDADE TABLET ===== */
@media (min-width: 769px) and (max-width: 1024px) {
  .reimbursement-card {
    padding: 1.25rem;
  }
}
</style>
